<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-12 col-lg-6 text-dark-blue">
        <div class="text-uppercase text-light-gold mb-4 pb-4 font-weight-bold">
          {{ title }}
        </div>
        <p>
          Please upload a copy of {{ title }} for
          {{ initial_lead.name || "your business" }}
        </p>
        <div
          class="bg-light-grey shadow-sm p-3 my-2 mx-1 rounded text-dark-blue"
        >
          <div class="d-flex justify-content-between font-weight-bold">
            {{ title }}
            <el-upload
              class="upload-demo"
              action=""
              :file-list="fileList"
              :on-change="handleUpload"
              :auto-upload="false"
              :show-file-list="false"
              v-if="onboardingAccount.is_completed == false"
            >
              <el-button class="btn-secondary">Upload</el-button>
            </el-upload>
          </div>
          <div v-if="fileList.length == 0">
            <div
              v-for="file in fileList.filter(
                (f) => f.media_collection_id == selectedMediaCollection
              )"
              class="fa-sm mt-2"
            >
              {{ file.name }}
            </div>
          </div>
          <div v-for="file in fileList" class="fa-sm mt-2">
            {{ file.name }}
          </div>
          <div
            class="fa-sm text-grey mt-1"
            v-for="media in initial_lead.onboarding_media"
          >
            <a :href="media.download_url" target="_blank">
              {{ media.file_name }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4 mt-4"></div>
    <div
      class="px-5 pb-4"
      style="position: absolute; bottom: 0; left: 0; right: 0"
    >
      <div class="d-flex justify-content-between">
        <el-button class="btn-secondary" @click="updateLead('prev')">
          Previous
        </el-button>
        <div>
          <el-button
            class="btn-secondary px-4"
            @click="updateLead('save')"
            v-if="onboardingAccount.is_completed == false"
          >
            Save Progress
          </el-button>
          <el-button class="btn-secondary" @click="updateLead('next')">
            Next
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initial_lead: {
      type: Object,
    },
    onboardingAccount: {
      type: Object,
    },
  },
  data() {
    return {
      fileList: [],
      selectedMediaCollection:
        this.initial_lead.business_type_id == 4 ? 44 : 43,
      title:
        this.initial_lead.business_type_id == 4
          ? "Trust Deed"
          : "Partnership Agreement",
    };
  },
  methods: {
    handleUpload(file) {
      let document = file;
      document.media_collection_id = this.selectedMediaCollection;
      this.fileList = [document];
    },
    updateLead(step) {
      let lead = this.initial_lead;
      lead.documents = this.fileList;
      this.$emit("update-lead", lead, step);
    },
  },
};
</script>
